import { motion } from "framer-motion";
import { FadeUp } from "../Reveal";
import { LuxButton } from "../LuxButton";
import { useUI } from "@/context/UIContext";

export const CtaStrip = () => {
  const { openEnquiry } = useUI();
  return (
    <section
      data-testid="cta-section"
      className="marble-bg relative overflow-hidden border-y border-[rgba(200,164,93,0.18)] py-24 md:py-28"
    >
      <motion.div
        className="pointer-events-none absolute left-0 top-0 h-px w-full bg-gradient-to-r from-transparent via-champagne to-transparent"
        initial={{ x: "-100%" }}
        whileInView={{ x: "100%" }}
        viewport={{ once: true }}
        transition={{ duration: 2.2, ease: "easeInOut", delay: 0.3 }}
        aria-hidden="true"
      />
      <div className="mx-auto flex max-w-[1280px] flex-col items-start gap-10 px-6 lg:flex-row lg:items-center lg:justify-between lg:px-12">
        <div>
          <FadeUp y={15}>
            <h2 className="font-serif text-3xl font-medium leading-tight text-ivory sm:text-4xl lg:text-[44px]">
              Experience a <span className="gold-text italic">higher standard</span>
            </h2>
          </FadeUp>
          <FadeUp delay={0.15}>
            <p className="mt-4 text-sm font-light text-ivory-muted">
              Join those who demand more from their lifestyle service.
            </p>
          </FadeUp>
        </div>
        <FadeUp delay={0.3} className="flex flex-wrap gap-4">
          <LuxButton to="/membership" testId="cta-join-button">
            Join
          </LuxButton>
          <LuxButton
            variant="outline"
            onClick={() => openEnquiry("Concierge")}
            testId="cta-enquire-button"
          >
            Enquire
          </LuxButton>
        </FadeUp>
      </div>
    </section>
  );
};
